import { Category, Eligibility, EntityType } from '@trace-8/trace8-schema';

export interface IEditInvestorFormData {
  [EditInvestorSectionNameEnum.Household]: {
    name: string;
    tenantId: string;
    tenantName: string;
    advisorId: string;
    advisorName: string;
    clientAdvisorOption: string;
  };
  [EditInvestorSectionNameEnum.EntityDetails]: {
    name: string;
    category?: keyof typeof Category;
    entityType?: keyof typeof EntityType;
    otherType?: string;
    eligibility?: (keyof typeof Eligibility)[];
    aboutInvestorNote?: string;
    entityInception?: string;
    newHouseholdName?: string;
    tenantId?: string;
    familyId?: string;
    taxStatus: EditInvestorEntityDetailsTaxStatusOptionEnum;
    investorHouseholdOption?: EditInvestorAddInvestorEntityInvestorHouseholdOptionEnum;
  };
  [EditInvestorSectionNameEnum.AllocationTargets]: {
    capacityCalculationOption: EditInvestorAllocationTargetsCapacityCalculationOptionEnum;
    assetClassTargetsOption: EditInvestorAllocationTargetsAssetClassTargetsOptionEnum;
    totalEntityValue: string;
    overCommitRatio: string;
    allocationTargets: Record<string, string>;
  };
  [EditInvestorSectionNameEnum.AllocationSettings]: {
    onHold: boolean;
    custodied: boolean;
    unmanaged: boolean;
    sri: string;
    alwaysShow: EditInvestorAllocationSettingsAlwaysShowOptionEnum;
    biteSizeOption: EditInvestorAllocationSettingsBiteSizeOptionEnum;
    sectorsToAvoid: string[];
    defaultBiteSize1: string;
    defaultBiteSize2: string;
  };
  [EditInvestorSectionNameEnum.DataIntegration]: {
    advisorCRMId: string;
    advisorReportingAccountNumber: string;
    administratorCode: string;
  };
}

export enum EditInvestorModalPageTypeEnum {
  AddInvestorEntity = 'add-investor-entity',
  Household = 'edit-household',
  EntityDetails = 'edit-entity-details',
  AllocationTargets = 'edit-allocation-targets',
  AllocationSettings = 'edit-allocation-settings',
  DataIntegration = 'edit-data-integration',
  EntityGrouping = 'edit-entity-grouping'
}

export enum EditInvestorSectionNameEnum {
  Household = 'household',
  EntityDetails = 'entityDetails',
  AllocationTargets = 'allocationTargets',
  AllocationSettings = 'allocationSettings',
  DataIntegration = 'dataIntegration'
}

export interface IEditInvestorSectionsData {
  title: string;
  name: EditInvestorSectionNameEnum;
  modalPageType: EditInvestorModalPageTypeEnum;
  formData: IEditInvestorFormData[keyof IEditInvestorFormData];
  displayData: { title: string; value: string | number | JSX.Element | null }[];
  isEmpty?: boolean;
}

export enum EditInvestorHouseholdClientAdvisorOptionEnum {
  None = 'None',
  AssignClientAdvisor = 'Assign a client advisor'
}

export enum EditInvestorAddInvestorEntityInvestorHouseholdOptionEnum {
  CreateNewInvestorHousehold = 'Create a new Investor Household',
  AssignToExisting = 'Assign to existing'
}

export enum EditInvestorEntityDetailsFormMode {
  Create = 'create',
  Update = 'update'
}

export enum EditInvestorEntityDetailsTaxStatusOptionEnum {
  US_TAXABLE = 'Taxable',
  US_TAX_EXEMPT = 'Exempt',
  NON_US = 'Non-US'
}

export enum EditInvestorAllocationTargetsCapacityCalculationOptionEnum {
  DisregardAllocationTargets = 'Disregard Allocation Targets',
  PacingModel = 'Pacing Model',
  OverCommitmentRatio = 'Over Commitment Ratio'
}

export enum EditInvestorAllocationTargetsAssetClassTargetsOptionEnum {
  UseDefaultAssetClassTargets = 'Use default asset class allocation targets',
  CustomizeTargetsForThisInvestorEntity = 'Customize targets for this investor entity'
}

export enum EditInvestorAllocationSettingsOnHoldOptionEnum {
  No = 'No',
  Yes = 'Yes'
}

export enum EditInvestorAllocationSettingsAlwaysShowOptionEnum {
  ShowRecommended = 'Show recommended',
  ShowAll = 'Show all'
}

export enum EditInvestorAllocationSettingsBiteSizeOptionEnum {
  UseMinimumRequiredCommitment = 'Use the minimum required commitment',
  SetSpecificDefaultBiteSize = 'Set a specific default bite size for this entity'
}
